module.exports = __webpack_public_path__ + "img/50.9cce8b53.jpg";